import {
  OrganizationalRole,
  StaffRepresentativeRole
} from '../../../../../utils/classes/graphql'
import {
  createKeysAndColumnNameArray,
  CellProps
} from '../../../../../components'
import { BASIC_DATE_FORMAT } from '../../../../../utils'

export const organizationalRolesKeysAndColumns: CellProps<OrganizationalRole>[] =
  createKeysAndColumnNameArray(
    'pages.ownInfoPage.assignments.organizationalRoles.',
    [
      {
        key: 'jarjestoyksikonNimi',
        translationIdPostfix: 'organization'
      },
      {
        key: 'tehtava',
        translationIdPostfix: 'assignment'
      },
      {
        key: 'aloituspvm',
        translationIdPostfix: 'startDate',
        dateFormat: BASIC_DATE_FORMAT
      },
      {
        key: 'lopetuspvm',
        translationIdPostfix: 'endDate',
        dateFormat: BASIC_DATE_FORMAT
      },
      {
        key: 'kaudenLopetuspvm',
        translationIdPostfix: 'periodEndDate',
        dateFormat: BASIC_DATE_FORMAT
      }
    ]
  )

export const staffRepresentativeRolesKeysAndColumns: CellProps<StaffRepresentativeRole>[] =
  createKeysAndColumnNameArray(
    'pages.ownInfoPage.assignments.staffRepresentativeRoles.',
    [
      {
        key: 'taNimi',
        translationIdPostfix: 'organization'
      },
      {
        key: 'tpNimi',
        translationIdPostfix: 'workplace'
      },
      {
        key: 'tehtava',
        translationIdPostfix: 'assignment'
      },
      {
        key: 'aloituspvm',
        translationIdPostfix: 'startDate',
        dateFormat: BASIC_DATE_FORMAT
      },
      {
        key: 'lopetuspvm',
        translationIdPostfix: 'endDate',
        dateFormat: BASIC_DATE_FORMAT
      },
      {
        key: 'kaudenLopetuspvm',
        translationIdPostfix: 'periodEndDate',
        dateFormat: BASIC_DATE_FORMAT
      }
    ]
  )
